// Top-bar с back-arrow + title. Source: stage-4-screens.md §4.
//
// onBack: если задано — рендерим кнопку «Назад» (стрелка). Если нет — слева пусто.
// title: опциональный текст рядом со стрелкой.
// right: HEAL-76 — слот справа (колокольчик). Необязательный: компонент стоит на
//   каждом экране приложения, и без слота разметка шапки не меняется ни на пиксель.

import { ChevronLeft } from 'lucide-react';
import type { ReactNode } from 'react';

export function ScreenHeader({
  onBack,
  title,
  right,
}: {
  onBack?: () => void;
  title?: string;
  right?: ReactNode;
}) {
  return (
    <div className="flex h-12 flex-shrink-0 items-center gap-2 px-3">
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          aria-label="Назад"
          className="flex h-9 w-9 items-center justify-center rounded-full hover-elevate active-elevate-2"
        >
          <ChevronLeft className="h-5 w-5" />
        </button>
      )}
      {title && <div className="text-base font-semibold">{title}</div>}
      {right && <div className="ml-auto flex items-center">{right}</div>}
    </div>
  );
}
